export default (props = {}) => <svg width="20" height="20" viewBox="0 0 20 20" fill="" xmlns="http://www.w3.org/2000/svg"{...props}>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.12109 16.5125L6.25 15.625L11.9893 9.81875L6.25 4.0125L7.12109 3.125L13.75 9.81875L7.12109 16.5125Z" fill=""/>
</svg>
